import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import './styles/searchingForAgent.scss';

class ChatSearchingForAgent extends Component {
  static propTypes = {
    reconnecting: PropTypes.bool.isRequired,
    reconnectingFailed: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    chatRequestId: PropTypes.number.isRequired,
    stoppedWaiting: PropTypes.bool.isRequired,
    routingTimedOut: PropTypes.bool.isRequired,
    queuePosition: PropTypes.string,
    showQueuePosition: PropTypes.bool.isRequired,
    queuePositionMessage: PropTypes.string,
    keepWaitingMessage: PropTypes.string,
    stopWaitingMessage: PropTypes.string,
    timeoutMessage: PropTypes.string,
    offeringToKeepWaiting: PropTypes.bool.isRequired,
    onKeepWaiting: PropTypes.func.isRequired,
    onStopWaiting: PropTypes.func.isRequired,
    onAbort: PropTypes.func.isRequired,
    isOutOfSchedule: PropTypes.bool,
    outOfScheduleMessage: PropTypes.string,
  };
  get title() {
    if (this.props.reconnectingFailed) {
      return 'Se perdió la conexión, actualice la página para volver a intentar';
    }

    if (this.props.reconnecting) {
      return 'Se perdió la conexión, reconectando';
    }

    if (this.props.isOutOfSchedule) {
      return this.props.outOfScheduleMessage;
    }

    return this.props.title;
  }
  renderPosition() {
    if (this.props.queuePositionMessage === '[conditional]') {
      const queuePosition = parseInt(this.props.queuePosition, 10) - 1;

      if (queuePosition !== queuePosition) {
        return '';
      } else if (queuePosition === 0) {
        return 'El próximo agente disponible te atenderá';
      }
      return `Hay ${queuePosition} persona${queuePosition === 1 ? '' : 's'} delante tuyo`;

    }
    return `${this.props.queuePositionMessage  } ${  this.props.queuePosition}`;

  }
  render() {
    return (
      <div className="chat-searching-wraper">
        {
          this.props.routingTimedOut ? (
            <h5 className="text-center">{this.props.timeoutMessage}</h5>
          ) : (
            this.props.stoppedWaiting ? (
              <h5 className="text-center">Te contactaremos por correo en breve, disculpa las molestias.</h5>
            ) : (
              <div>
                <h4 className="text-center">{this.title}</h4>
                {this.props.reconnectingFailed ? undefined : (
                  <B.ProgressBar striped active now={100}/>
                )}
                {
                  !this.props.reconnecting && this.props.showQueuePosition ? (
                    <h5 className="text-center">{this.renderPosition()}</h5>
                  ) : undefined
                }
                {
                  !this.props.reconnecting && this.props.offeringToKeepWaiting ? (
                    <div className="chat-searching-offer-wraper text-center">
                      <B.Button bsStyle="primary" onClick={this.props.onKeepWaiting}>
                        { this.props.keepWaitingMessage }
                      </B.Button>
                      <br /><br />
                      <B.Button bsStyle="warning" onClick={this.props.onStopWaiting.bind(null, this.props.chatRequestId, this.props.onAbort)}>
                        { this.props.stopWaitingMessage }
                      </B.Button>
                    </div>
                  ) : undefined
                }
              </div>
            )
          )
        }
      </div>
    );
  }
}

export default ChatSearchingForAgent;



// WEBPACK FOOTER //
// ./components/chat/SearchingForAgent.js